import { TypeInputFreeformDate } from '@/core/generated-types';
import moment from 'moment';
import { ChildBirthDateInput } from '@/utils/dates/constants';
import { childBirthDateToDateString } from '@/utils/dates/dateFormatters';

export function validateChildBirthDate(
  event: any,
  date: Date,
  childBirthDate: ChildBirthDateInput,
  childBirthDateInput?: TypeInputFreeformDate,
) {
  const { target: form } = event;
  const formFields = form.elements;

  // No freeform date field.
  if (!childBirthDateInput) {
    return '';
  }

  // No data was entered.
  if (!childBirthDate.year && !childBirthDate.month && !childBirthDate.day) {
    if (childBirthDateInput.fields.required) {
      return childBirthDateInput.fields.requiredError || '';
    } else {
      return '';
    }
  }

  // At least one date fragment is empty.
  if (!childBirthDate.year || !childBirthDate.month || !childBirthDate.day) {
    return childBirthDateInput.fields.incompleteDateError;
  }

  const yearId = `${childBirthDateInput.fields.id}-year`;
  const monthId = `${childBirthDateInput.fields.id}-month`;
  const dayId = `${childBirthDateInput.fields.id}-day`;

  const yearIsValid = formFields[yearId]?.checkValidity();
  const monthIsValid = formFields[monthId]?.checkValidity();
  const dayIsValid = formFields[dayId]?.checkValidity();

  // Input is not a plausible date based on provided patterns (e.g., February 29 on a non-leap year, April 31, month=13, or day=90, or year=870).
  if (!yearIsValid || !monthIsValid || !dayIsValid || isNaN(date.getTime())) {
    return childBirthDateInput.fields.invalidDateError;
  }
  const dateString = childBirthDateToDateString(childBirthDate);
  const childBirthDateInputAsMoment = moment(dateString);
  const isDateTooFarInFuture = childBirthDateInputAsMoment.isAfter(
    moment().add(9, 'months'),
  );
  const isDateTooFarInPast = childBirthDateInputAsMoment.isBefore(
    moment().subtract(18, 'years'),
  );

  if (isDateTooFarInFuture) {
    return childBirthDateInput.fields.futureDateError || '';
  }

  if (isDateTooFarInPast) {
    return childBirthDateInput.fields.tooOldError || '';
  }

  return '';
}
